/**
 * Lista de países y sus principales ciudades.
 * Foco en LATAM + países comunes para turismo internacional.
 *
 * Para Colombia: lista comprehensiva (32 departamentos + capitales + ciudades grandes)
 * Para otros países: principales ciudades
 */

export const PAISES_CIUDADES = {
  "Colombia": [
    "Bogotá D.C.",
    "Medellín",
    "Cali",
    "Cartagena",
    "Barranquilla",
    "Santa Marta",
    "Bucaramanga",
    "Cúcuta",
    "Pereira",
    "Manizales",
    "Armenia",
    "Ibagué",
    "Villavicencio",
    "Neiva",
    "Pasto",
    "Popayán",
    "Montería",
    "Sincelejo",
    "Valledupar",
    "Riohacha",
    "Tunja",
    "Quibdó",
    "Leticia",
    "Florencia",
    "Yopal",
    "Mocoa",
    "San Andrés",
    "Providencia",
    "Mitú",
    "Puerto Carreño",
    "Inírida",
    "San José del Guaviare",
    "Arauca",
    "Tuluá",
    "Palmira",
    "Buenaventura",
    "Rionegro",
    "Itagüí",
    "Envigado",
    "Bello",
    "Soacha",
    "Turbaco",
    "Soledad",
    "Girardot",
    "Zipaquirá",
    "Chía",
    "Fusagasugá",
    "Barú",
  ],
  "México": [
    "Ciudad de México",
    "Guadalajara",
    "Monterrey",
    "Puebla",
    "Tijuana",
    "León",
    "Ciudad Juárez",
    "Zapopan",
    "Mérida",
    "Cancún",
    "Playa del Carmen",
    "Tulum",
    "Acapulco",
    "Veracruz",
    "Oaxaca",
    "Querétaro",
    "Toluca",
    "Aguascalientes",
    "San Luis Potosí",
    "Morelia",
    "Hermosillo",
    "Saltillo",
    "Culiacán",
    "Mazatlán",
    "Tampico",
    "Chihuahua",
    "Cuernavaca",
    "Puerto Vallarta",
    "Los Cabos",
    "Cozumel",
  ],
  "Estados Unidos": [
    "New York",
    "Los Angeles",
    "Chicago",
    "Houston",
    "Phoenix",
    "Philadelphia",
    "San Antonio",
    "San Diego",
    "Dallas",
    "Miami",
    "Orlando",
    "Tampa",
    "Atlanta",
    "Boston",
    "Washington D.C.",
    "Las Vegas",
    "San Francisco",
    "Seattle",
    "Denver",
    "Austin",
    "Charlotte",
    "Nashville",
  ],
  "España": [
    "Madrid",
    "Barcelona",
    "Valencia",
    "Sevilla",
    "Zaragoza",
    "Málaga",
    "Murcia",
    "Palma de Mallorca",
    "Las Palmas",
    "Bilbao",
    "Alicante",
    "Córdoba",
    "Valladolid",
    "Vigo",
    "Granada",
    "Santander",
    "Gijón",
    "Pamplona",
    "San Sebastián",
    "Santiago de Compostela",
  ],
  "Argentina": [
    "Buenos Aires",
    "Córdoba",
    "Rosario",
    "Mendoza",
    "La Plata",
    "San Miguel de Tucumán",
    "Mar del Plata",
    "Salta",
    "Santa Fe",
    "San Juan",
    "Resistencia",
    "Bariloche",
    "Ushuaia",
    "El Calafate",
    "Puerto Iguazú",
  ],
  "Chile": [
    "Santiago",
    "Valparaíso",
    "Viña del Mar",
    "Concepción",
    "La Serena",
    "Antofagasta",
    "Iquique",
    "Temuco",
    "Puerto Montt",
    "Punta Arenas",
    "San Pedro de Atacama",
    "Puerto Natales",
    "Pucón",
  ],
  "Perú": [
    "Lima",
    "Arequipa",
    "Trujillo",
    "Chiclayo",
    "Piura",
    "Cusco",
    "Iquitos",
    "Huancayo",
    "Tacna",
    "Puno",
    "Máncora",
    "Paracas",
    "Nazca",
    "Puerto Maldonado",
  ],
  "Ecuador": [
    "Quito",
    "Guayaquil",
    "Cuenca",
    "Manta",
    "Galápagos (Puerto Ayora)",
    "Ambato",
    "Loja",
    "Machala",
    "Portoviejo",
    "Salinas",
    "Baños",
  ],
  "Venezuela": [
    "Caracas",
    "Maracaibo",
    "Valencia",
    "Barquisimeto",
    "Maracay",
    "Ciudad Guayana",
    "San Cristóbal",
    "Mérida",
    "Margarita (Porlamar)",
    "Cumaná",
  ],
  "Panamá": [
    "Ciudad de Panamá",
    "Colón",
    "David",
    "Santiago",
    "Chitré",
    "La Chorrera",
    "Bocas del Toro",
    "Boquete",
    "Pedasí",
  ],
  "Brasil": [
    "São Paulo",
    "Rio de Janeiro",
    "Brasília",
    "Salvador",
    "Fortaleza",
    "Belo Horizonte",
    "Manaus",
    "Curitiba",
    "Recife",
    "Porto Alegre",
    "Florianópolis",
    "Foz do Iguaçu",
    "Búzios",
    "Natal",
    "Jericoacoara",
  ],
  "Canadá": [
    "Toronto",
    "Montreal",
    "Vancouver",
    "Calgary",
    "Ottawa",
    "Edmonton",
    "Quebec",
    "Winnipeg",
    "Halifax",
    "Victoria",
  ],
  "Reino Unido": [
    "Londres",
    "Manchester",
    "Birmingham",
    "Edimburgo",
    "Glasgow",
    "Liverpool",
    "Bristol",
    "Cardiff",
    "Belfast",
  ],
  "Francia": [
    "París",
    "Marsella",
    "Lyon",
    "Toulouse",
    "Niza",
    "Nantes",
    "Burdeos",
    "Estrasburgo",
    "Lille",
  ],
  "Alemania": [
    "Berlín",
    "Hamburgo",
    "Múnich",
    "Colonia",
    "Frankfurt",
    "Stuttgart",
    "Düsseldorf",
  ],
  "Italia": [
    "Roma",
    "Milán",
    "Nápoles",
    "Turín",
    "Florencia",
    "Venecia",
    "Bolonia",
    "Palermo",
    "Verona",
  ],
  "Costa Rica": [
    "San José",
    "Alajuela",
    "Cartago",
    "Heredia",
    "Liberia",
    "Puntarenas",
    "Jacó",
    "Manuel Antonio",
    "Tamarindo",
    "Monteverde",
  ],
  "República Dominicana": [
    "Santo Domingo",
    "Santiago",
    "Puerto Plata",
    "La Romana",
    "Punta Cana",
    "Bávaro",
    "Samaná",
  ],
  "Cuba": [
    "La Habana",
    "Varadero",
    "Santiago de Cuba",
    "Trinidad",
    "Camagüey",
    "Cienfuegos",
    "Holguín",
  ],
  "Uruguay": [
    "Montevideo",
    "Punta del Este",
    "Colonia del Sacramento",
    "Salto",
    "Paysandú",
    "Maldonado",
  ],
  "Paraguay": [
    "Asunción",
    "Ciudad del Este",
    "Encarnación",
    "San Lorenzo",
    "Pedro Juan Caballero",
  ],
  "Bolivia": [
    "La Paz",
    "Santa Cruz de la Sierra",
    "Cochabamba",
    "Sucre",
    "Potosí",
    "Oruro",
    "Uyuni",
    "Copacabana",
  ],
  "Guatemala": [
    "Ciudad de Guatemala",
    "Antigua Guatemala",
    "Quetzaltenango",
    "Escuintla",
    "Tikal (Petén)",
    "Panajachel",
  ],
  "Honduras": [
    "Tegucigalpa",
    "San Pedro Sula",
    "La Ceiba",
    "Roatán",
    "Comayagua",
  ],
  "El Salvador": [
    "San Salvador",
    "Santa Ana",
    "San Miguel",
    "La Libertad",
    "Sonsonate",
  ],
  "Nicaragua": [
    "Managua",
    "León",
    "Granada",
    "Masaya",
    "San Juan del Sur",
  ],
  "Puerto Rico": [
    "San Juan",
    "Ponce",
    "Mayagüez",
    "Bayamón",
    "Caguas",
  ],
  "Otro": ["(especificar en dirección)"],
};

// Prefijos telefónicos internacionales por país
export const PREFIJOS_TELEFONICOS = {
  "Colombia": "+57",
  "México": "+52",
  "Estados Unidos": "+1",
  "España": "+34",
  "Argentina": "+54",
  "Chile": "+56",
  "Perú": "+51",
  "Ecuador": "+593",
  "Venezuela": "+58",
  "Panamá": "+507",
  "Brasil": "+55",
  "Canadá": "+1",
  "Reino Unido": "+44",
  "Francia": "+33",
  "Alemania": "+49",
  "Italia": "+39",
  "Costa Rica": "+506",
  "República Dominicana": "+1",
  "Cuba": "+53",
  "Uruguay": "+598",
  "Paraguay": "+595",
  "Bolivia": "+591",
  "Guatemala": "+502",
  "Honduras": "+504",
  "El Salvador": "+503",
  "Nicaragua": "+505",
  "Puerto Rico": "+1",
  "Otro": "",
};

export const PAISES = Object.keys(PAISES_CIUDADES).sort((a, b) => {
  // Colombia primero, luego México, luego alfabético
  if (a === 'Colombia') return -1;
  if (b === 'Colombia') return 1;
  if (a === 'México') return -1;
  if (b === 'México') return 1;
  if (a === 'Otro') return 1;
  if (b === 'Otro') return -1;
  return a.localeCompare(b);
});
